import { useEffect } from 'react';

import { Globals, useReducedMotion } from 'react-spring';
import { IS_PLAYWRIGHT } from 'src/helpers/environment';

/**
 * Automatically disable all react-spring animations if the user prefers reduced motion, and also in
 * Playwright tests to make Percy snapshots more predictable.
 */
export function useReactSpringReducedMotion() {
  const reducedMotion = useReducedMotion() ?? false;
  const skipAnimation = reducedMotion || IS_PLAYWRIGHT;

  useEffect(() => {
    Globals.assign({ skipAnimation });
  }, [skipAnimation]);
}
